import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import CreateScriptSection from '../components/ScriptGeneration/CreateScriptSection';
import {
  PaintBrushIcon,
  VideoCameraIcon,
  SpeakerWaveIcon,
  FilmIcon,
  SparklesIcon
} from '@heroicons/react/24/outline';

interface FeatureCardProps {
  title: string;
  description: string;
  icon: React.ReactNode;
  gradient: string;
  onClick: () => void;
}

const FeatureCard: React.FC<FeatureCardProps> = ({ title, description, icon, gradient, onClick }) => (
  <div
    onClick={onClick}
    className="bg-bg-surface/40 hover:bg-bg-elevated border border-border-subtle rounded-2xl p-5 flex items-center gap-4 cursor-pointer transition-all duration-300 hover:border-primary hover:-translate-y-1 hover:shadow-[0_0_20px_rgba(255,92,0,0.15)] group"
  >
    <div className={`w-12 h-12 rounded-xl flex items-center justify-center shrink-0 shadow-lg group-hover:shadow-[0_0_20px_rgba(255,92,0,0.3)] transition-all ${gradient}`}>
      {icon}
    </div>
    <div className="flex flex-col">
      <span className="text-gray-50 font-medium text-sm">{title}</span>
      <span className="text-gray-500 text-xs mt-0.5 group-hover:text-gray-400 transition-colors">{description}</span>
    </div>
  </div>
);

export default function DashboardPage() {
  const navigate = useNavigate();
  const { t } = useTranslation('app');

  const features = [
    // {
    //   title: '影片生成',
    //   description: '单集快速创作',
    //   icon: <FilmIcon className="w-6 h-6 text-white" />,
    //   gradient: 'bg-gradient-to-br from-indigo-500 to-purple-600',
    //   path: '/short-video'
    // },
    {
      title: t('dashboard.features.episodeCreation'),
      description: t('dashboard.features.episodeCreationDesc'),
      icon: <SparklesIcon className="w-6 h-6 text-white" />,
      gradient: 'bg-gradient-to-br from-primary to-primary-light',
      path: '/projects'
    },
    {
      title: t('dashboard.features.imageGeneration'),
      description: t('dashboard.features.imageGenerationDesc'),
      icon: <PaintBrushIcon className="w-6 h-6 text-white" />,
      gradient: 'bg-gradient-to-br from-cyan-400 to-blue-500',
      path: '/image-generation'
    },
    {
      title: t('dashboard.features.audioGeneration'),
      description: t('dashboard.features.audioGenerationDesc'),
      icon: <SpeakerWaveIcon className="w-6 h-6 text-white" />,
      gradient: 'bg-gradient-to-br from-green-400 to-green-600',
      path: '/audio-generation'
    },
    {
      title: t('dashboard.features.videoGeneration'),
      description: t('dashboard.features.videoGenerationDesc'),
      icon: <VideoCameraIcon className="w-6 h-6 text-white" />,
      gradient: 'bg-gradient-to-br from-orange-400 to-red-500',
      path: '/video-generation'
    }
  ];

  return (
    <div className="min-h-screen bg-bg-page flex flex-col items-center justify-center px-4 pb-20">
      <div className="w-full max-w-5xl">
        {/* Create Agent Section */}
        <CreateScriptSection showScriptTab />

        {/* Feature Quick Access Cards */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8 px-4">
          {features.map((feature, index) => (
            <FeatureCard
              key={index}
              {...feature}
              onClick={() => navigate(feature.path)}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
